// assets
import {
  SendOutlined,
  ScheduleOutlined,
  SettingOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  StockOutlined,
} from '@ant-design/icons';


// icons
const icons = {
  SendOutlined,
  ScheduleOutlined,
  SettingOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  StockOutlined,
};

// ==============================|| MENU ITEMS - MANAGEMENT ||============================== //

const grocery = {
  id: 'group-grocery',
  title: 'MANAGEMENT',
  type: 'group',
  children: [
    {
      id: 'send-update',
      title: 'WhatsApp Alerts',
      type: 'item',
      url: '/send-update',
      icon: icons.MessageOutlined,
      breadcrumbs: false
    },
    {
      id: 'preferred-time',
      title: 'Delivery Time',
      type: 'item',
      url: '/preferred-time',
      icon: icons.ClockCircleOutlined,
      breadcrumbs: false
    },
    {
      id: 'payment',
      title: 'Payment',
      type: 'item',
      url: '/payment',
      icon: icons.SendOutlined,
      breadcrumbs: false
    },
    {
      id: 'stock-unit',
      title: 'Stock Unit',
      type: 'item',
      url: '/stock-units',
      icon: icons.StockOutlined,
      breadcrumbs: false
    },
    {
      id: 'Setting',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    }

  ]
};

export default grocery;




